import React from 'react'
// import { toTop } from '../../utils/animationFunctions'

export default function OverLayIU(props) {
    // toTop()
    return (
        <div className={`overlay overlay--${props.type} overlay--${props.overlay}`} onClick={()=>{
            props.onClick()
        }}>
        </div>

    )
}
